export const CLINIC_LOGO_UPDATED = "dental-os:clinic-logo-updated";
